var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64998 12.2719H9.34998V5.57812H11.9L8.49998 0L5.09998 5.57812H7.64998V12.2719Z",
    fill: "#2563EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 15.6188H1.7V7.80939H0V15.6188C0 16.8493 0.76245 17.85 1.7 17.85H15.3C16.2376 17.85 17 16.8493 17 15.6188V7.80939H15.3V15.6188Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a6071e3d72636648642a23101e7e0970.svg";
export { ForwardRef as ReactComponent };